import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import ENDPOINT from "../../context/EndPoint";
import { useParams } from "react-router";
import { Avatar } from "@mui/material";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

const PlacementItem = ({ item }) => {
  const { user } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [studentId, setStudentId] = useState("");
  const [technicalProficiency, setTechnicalProficiency] = useState("");
  const [aiAwareness, setAiAwareness] = useState("");
  const [problemSolving, setProblemSolving] = useState("");
  const [softSkills, setSoftSkills] = useState("");
  const [adaptability, setAdaptability] = useState("");
  const [continuousLearning, setContinuousLearning] = useState("");
  const [innovation, setInnovation] = useState("");
  const [dataLiteracy, setDataLiteracy] = useState("");
  const [networking, setNetworking] = useState("");
  const [personalBranding, setPersonalBranding] = useState("");
  const [culturalAwareness, setCulturalAwareness] = useState("");
  const [roleSpecificSkills, setRoleSpecificSkills] = useState("");
  const [resilience, setResilience] = useState("");
  const [communication, setCommunication] = useState("");
  const [collaboration, setCollaboration] = useState("");
  const [creativity, setCreativity] = useState("");
  const [workEthic, setWorkEthic] = useState("");
  const [leadership, setLeadership] = useState("");
  const [entrepreneurship, setEntrepreneurship] = useState("");
  const [agility, setAgility] = useState("");
  const [globalAwareness, setGlobalAwareness] = useState("");
  const [ethics, setEthics] = useState("");
  const [timeManagement, setTimeManagement] = useState("");
  const [criticalThinking, setCriticalThinking] = useState("");
  const [productivity, setProductivity] = useState("");
  const [mentorship, setMentorship] = useState("");
  const [decisionMaking, setDecisionMaking] = useState("");
  const [attentionToDetail, setAttentionToDetail] = useState("");
  const [emotionalIntelligence, setEmotionalIntelligence] = useState("");
  const [selfMotivation, setSelfMotivation] = useState("");
  const [accountability, setAccountability] = useState("");
  const [interpersonalSkills, setInterpersonalSkills] = useState("");
  const [feedbackReception, setFeedbackReception] = useState("");
  const [stressManagement, setStressManagement] = useState("");
  const [selfDiscipline, setSelfDiscipline] = useState("");
  const [publicSpeaking, setPublicSpeaking] = useState("");
  const [innovationThinking, setInnovationThinking] = useState("");
  const [projectManagement, setProjectManagement] = useState("");
  const [technicalAdaptability, setTechnicalAdaptability] = useState("");
  const [workplaceMaturity, setWorkplaceMaturity] = useState("");
  const [conflictResolution, setConflictResolution] = useState("");
  const [goalOrientation, setGoalOrientation] = useState("");
  const [researchSkills, setResearchSkills] = useState("");
  const [customerFocus, setCustomerFocus] = useState("");
  const [teamwork, setTeamwork] = useState("");
  const [multitasking, setMultitasking] = useState("");
  const [vision, setVision] = useState("");
  const [persistence, setPersistence] = useState("");
  const [selfImprovement, setSelfImprovement] = useState("");
  const [businessAcumen, setBusinessAcumen] = useState("");
  const [attendance, setAttendance] = useState("");
  const [resumeScore, setResumeScore] = useState("");
 
 const dispatch = useDispatch()

  const params = useParams();
  console.log(params.id);

  const getUserData = async () => {
    dispatch({ type: 'LOADING' });
  
    const Data = new FormData();
    Data.append("session", user.SessionId);
    Data.append("user_id", params.id);
    Data.append("query", 1);
  
    try {
      const res = await axios.post(
        ENDPOINT +"single-student-placement.php",
        Data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        setUserData(res.data.data);
        console.log(res.data.data.user_technical_skills[0].title);
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'No data found or unauthorized access' 
        });
        setError("No data found or unauthorized access");
      }
    } catch (err) {
      dispatch({ 
        type: 'ERROR', 
        payload: err.message || 'An error occurred while fetching user data' 
      });
      setError("Error fetching data: " + err.message);
    }
  };

  // Fetch user data on component mount
  useEffect(() => {
    getUserData();
  }, []);

 

  const handleSubmit = async (e) => {
    dispatch({type:'LOADING'})
    e.preventDefault();

    const formData = new FormData();
    formData.append("session", user.SessionId);
    formData.append("user_id", params.id);
    formData.append("student_id", studentId);
    formData.append("technical_proficiency", technicalProficiency);
    formData.append("ai_awareness", aiAwareness);
    formData.append("problem_solving", problemSolving);
    formData.append("soft_skills", softSkills);
    formData.append("adaptability", adaptability);
    formData.append("continuous_learning", continuousLearning);
    formData.append("innovation", innovation);
    formData.append("data_literacy", dataLiteracy);
    formData.append("networking", networking);
    formData.append("personal_branding", personalBranding);
    formData.append("cultural_awareness", culturalAwareness);
    formData.append("role_specific_skills", roleSpecificSkills);
    formData.append("resilience", resilience);
    formData.append("communication", communication);
    formData.append("collaboration", collaboration);
    formData.append("creativity", creativity);
    formData.append("work_ethic", workEthic);
    formData.append("leadership", leadership);
    formData.append("entrepreneurship", entrepreneurship);
    formData.append("agility", agility);
    formData.append("global_awareness", globalAwareness);
    formData.append("ethics", ethics);
    formData.append("time_management", timeManagement);
    formData.append("critical_thinking", criticalThinking);
    formData.append("productivity", productivity);
    formData.append("mentorship", mentorship);
    formData.append("decision_making", decisionMaking);
    formData.append("attention_to_detail", attentionToDetail);
    formData.append("emotional_intelligence", emotionalIntelligence);
    formData.append("self_motivation", selfMotivation);
    formData.append("accountability", accountability);
    formData.append("interpersonal_skills", interpersonalSkills);
    formData.append("feedback_reception", feedbackReception);
    formData.append("stress_management", stressManagement);
    formData.append("self_discipline", selfDiscipline);
    formData.append("public_speaking", publicSpeaking);
    formData.append("innovation_thinking", innovationThinking);
    formData.append("project_management", projectManagement);
    formData.append("technical_adaptability", technicalAdaptability);
    formData.append("workplace_maturity", workplaceMaturity);
    formData.append("conflict_resolution", conflictResolution);
    formData.append("goal_orientation", goalOrientation);
    formData.append("research_skills", researchSkills);
    formData.append("customer_focus", customerFocus);
    formData.append("teamwork", teamwork);
    formData.append("multitasking", multitasking);
    formData.append("vision", vision);
    formData.append("persistence", persistence);
    formData.append("self_improvement", selfImprovement);
    formData.append("business_acumen", businessAcumen);
    formData.append("attendance", attendance);
    formData.append("resume_score", resumeScore);

    try {
      const res = await axios.post(
        ENDPOINT +"add-single-student-placement.php", 
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.data.status === "success") {
    dispatch({type:'DONE_LOADING'})

      } else {
           dispatch({type:'ERROR',payload:'Error occurred while updating'})

      }
    } catch (err) {
      dispatch({type:'ERROR',payload:err.message})

    }
  };

  return (
    <>
      {userData ? (
        <>
          <div className="container-fluid">
            <div className="profile-foreground position-relative mx-n4 mt-n4">
              <div
                className="profile-wid-bg d-sm-block d-block d-md-none"
                style={{ height: "25vh" }}
              >
                <img
                  src="assets/images/profile-bg.jpg"
                  alt=""
                  className="profile-wid-img"
                />
              </div>
              <div className="profile-wid-bg d-sm-none d-none d-lg-block d-md-block ">
                <img
                  src="assets/images/profile-bg.jpg"
                  alt=""
                  className="profile-wid-img"
                />
              </div>
            </div>
            <div className="pt-4 profile-wrapper">
              <div className="row pb-lg-3 pb-0">
                <div className="col-auto">
                  <div className="avatar-lg">
                    <img
                      src={userData.profile_pic ? userData.profile_pic : null}
                      alt="user-img"
                      className="img-thumbnail rounded-circle"
                    />
                  </div>
                </div>
                {/*end col*/}
                <div className="col ">
                  <div className="">
                    <h3 className="text-white mb-1 fs-16 d-lg-none d-md-none">
                      {userData.first_name + " " + userData.last_name}
                    </h3>
                    <p className="text-white text-opacity-75 mb-1 d-lg-none d-md-none fs-25">
                      {userData.course_url}
                    </p>
                    <div>
                      <span className="badge bg-warning text-light">
                        Good Match
                      </span>
                    </div>
                    <div className=" text-white-50 gap-1 d-lg-none d-md-none">
                      <div className="me-2 ">
                        <i className=" me-1 text-white text-opacity-75 fs-16 align-middle" />
                        Batch :{userData.user_id}
                      </div>

                      <div className="me-2 ">
                        <i className=" me-1 text-white text-opacity-75 fs-16 align-middle" />
                        StudentID :{userData.student_id}
                      </div>
                    </div>

                    <h3 className="text-white mb-1 d-sm-none d-xs-none d-lg-block d-md-block d-none">
                      {userData.first_name + " " + userData.last_name}
                    </h3>
                    <p className="text-white text-opacity-75 mb-1 d-sm-none d-xs-none d-lg-block d-md-block d-none">
                      {userData.course_url}
                    </p>
                    <div className="hstack text-white-50 gap-1 d-sm-none d-xs-none d-lg-block d-md-block d-none">
                      <div className="me-2">
                        <i className=" me-1 text-white text-opacity-75 fs-16 align-middle" />
                        Batch : {userData.user_id}
                      </div>

                      <div className="me-2">
                        <i className=" me-1 text-white text-opacity-75 fs-16 align-middle" />
                        Student ID : {userData.student_id}
                      </div>
                    </div>
                  </div>
                </div>
                {/*end col*/}
                <div className="col-12 col-lg-auto order-last order-lg-0"></div>
                {/*end col*/}
              </div>
              <div class="dropdown ms-1 d-flex justify-content-end">
                <button
                  type="button"
                  class="btn btn btn-soft-success btn-topbar btn-ghost-secondary rounded "
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Update
                </button>
                <div class="dropdown-menu col-lg-7 p-0 dropdown-menu-end">
                  <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                    <div class="row align-items-center">
                      <div class="col">
                        <h6 class="m-0 fw-semibold fs-15"> Quick Actions </h6>
                      </div>
                      <div class="col-auto">
                        <Link to="#!" class="btn btn-sm btn-soft-info">
                          {" "}
                          View All
                          <i class="ri-arrow-right-s-line align-middle"></i>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div class="p-2 w-100 vh-75 overflow-y">
                    <form>
                      <div class="row g-0 ">
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Technical Proficiency
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Technical Proficiency"
                            value={userData.technical_proficiency}
                            onChange={(e) => setTechnicalProficiency(e.target.value)}
                            placeholder="Technical Proficiency"
                          />
                        </div>
                        <div className="mb-3 col-lg-4 px-1">
                          <label className="form-label">AI Awareness</label>
                          <input
                            type="number"
                            className="form-control"
                            name="AI Awareness"
                            value={userData.ai_awareness}
                            onChange={(e) => setAiAwareness(e.target.value)}
                            placeholder="AI Awareness"
                          />
                        </div>
                        <div className="mb-3 col-lg-4 px-1">
                          <label className="form-label">Problem Solving</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Problem Solving"
                            value={userData.problem_solving}
                            onChange={(e) => setProblemSolving(e.target.value)}
                            placeholder="Problem Solving"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Soft Skills</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Soft Skills"
                            value={userData.soft_skills}
                            onChange={(e) => setSoftSkills(e.target.value)}
                            placeholder="Soft Skills"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Adaptability</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Adaptability"
                            value={userData.adaptability}
                            onChange={(e) => setAdaptability(e.target.value)}
                            placeholder="Adaptability"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Continuous Learning
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Continuous Learning"
                            value={userData.continuous_learning}
                            onChange={(e) => setContinuousLearning(e.target.value)}
                            placeholder="Continuous Learning"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Innovation</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Innovation"
                            value={userData.innovation}
                            onChange={(e) => setInnovation(e.target.value)}
                            placeholder="Innovation"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Data Literacy</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Data Literacy"
                            value={userData.data_literacy}
                            onChange={(e) => setDataLiteracy(e.target.value)}
                            placeholder="Data Literacy"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Networking</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Networking"
                            value={userData.networking}
                            onChange={(e) => setNetworking(e.target.value)}
                            placeholder="Networking"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Personal Branding
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Personal Branding"
                            value={userData.personal_branding}
                            onChange={(e) => setPersonalBranding(e.target.value)}
                            placeholder="Personal Branding"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Cultural Awareness
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Cultural Awareness"
                            value={userData.cultural_awareness}
                            onChange={(e) => setCulturalAwareness(e.target.value)}
                            placeholder="Cultural Awareness"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Role Specific Skills
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Role Specific Skills"
                            value={userData.role_specific_skills}
                            onChange={(e) => setRoleSpecificSkills(e.target.value)}
                            placeholder="Role Specific Skills"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Resilience</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Resilience"
                            value={userData.resilience}
                            onChange={(e) => setResilience(e.target.value)}
                            placeholder="Resilience"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Communication</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Communication"
                            value={userData.communication}
                            onChange={(e) => setCommunication(e.target.value)}
                            placeholder="Communication"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Collaboration</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Collaboration"
                            value={userData.collaboration}
                            onChange={(e) => setCollaboration(e.target.value)}
                            placeholder="Collaboration"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Creativity</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Creativity"
                            value={userData.creativity}
                            onChange={(e) => setCreativity(e.target.value)}
                            placeholder="Creativity"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Work Ethic</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Work Ethic"
                            value={userData.work_ethic}
                            onChange={(e) => setWorkEthic(e.target.value)}
                            placeholder="Work Ethic"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Leadership</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Leadership"
                            value={userData.leadership}
                            onChange={(e) => setLeadership(e.target.value)}
                            placeholder="Leadership"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Entrepreneurship</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Entrepreneurship"
                            value={userData.entrepreneurship}
                            onChange={(e) => setEntrepreneurship(e.target.value)}
                            placeholder="Entrepreneurship"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Agility</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Agility"
                            value={userData.agility}
                            onChange={(e) =>  setAgility(e.target.value)}
                            placeholder="Agility"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Global Awareness</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Global Awareness"
                            value={userData.global_awareness}
                            onChange={(e) => setGlobalAwareness(e.target.value)}
                            placeholder="Global Awareness"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Ethics</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Ethics"
                            value={userData.ethics}
                            onChange={(e) => setEthics(e.target.value)}
                            placeholder="Ethics"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Time Management</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Time Management"
                            value={userData.time_management}
                            onChange={(e) => setTimeManagement(e.target.value)}
                            placeholder="Time Management"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Critical Thinking
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Critical Thinking"
                            value={userData.critical_thinking}
                            onChange={(e) => setCriticalThinking(e.target.value)}
                            placeholder="Critical Thinking"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Productivity</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Productivity"
                            value={userData.productivity}
                            onChange={(e) => setProductivity(e.target.value)}
                            placeholder="Productivity"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Mentorship</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Mentorship"
                            value={userData.mentorship}
                            onChange={(e) => setMentorship(e.target.value)}
                            placeholder="Mentorship"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Decision Making</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Decision Making"
                            value={userData.decision_making}
                            onChange={(e) => setDecisionMaking(e.target.value)}
                            placeholder="Decision Making"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Attention to Detail
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Attention to Detail"
                            value={userData.attention_to_detail}
                            onChange={(e) => setAttentionToDetail(e.target.value)}
                            placeholder="Attention to Detail"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Emotional Intelligence
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Emotional Intelligence"
                            value={userData.emotional_intelligence}
                            onChange={(e) => setEmotionalIntelligence(e.target.value)}
                            placeholder="Emotional Intelligence"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Self Motivation</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Self Motivation"
                            value={userData.self_motivation}
                            onChange={(e) => setSelfMotivation(e.target.value)}
                            placeholder="Self Motivation"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Accountability</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Accountability"
                            value={userData.accountability}
                            onChange={(e) => setAccountability(e.target.value)}
                            placeholder="Accountability"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Interpersonal Skills
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Interpersonal Skills"
                            value={userData.interpersonal_skills}
                            onChange={(e) => setInterpersonalSkills(e.target.value)}
                            placeholder="Interpersonal Skills"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Feedback Reception
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Feedback Reception"
                            value={userData.feedback_reception}
                            onChange={(e) => setFeedbackReception(e.target.value)}
                            placeholder="Feedback Reception"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Stress Management
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Stress Management"
                            value={userData.stress_management}
                            onChange={(e) => setStressManagement(e.target.value)}
                            placeholder="Stress Management"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Self Discipline</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Self Discipline"
                            value={userData.self_discipline}
                            onChange={(e) => setSelfDiscipline(e.target.value)}
                            placeholder="Self Discipline"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Public Speaking</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Public Speaking"
                            value={userData.public_speaking}
                            onChange={(e) => setPublicSpeaking(e.target.value)}
                            placeholder="Public Speaking"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Innovation Thinking
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Innovation Thinking"
                            value={userData.innovation_thinking}
                            onChange={(e) => setInnovationThinking(e.target.value)}
                            placeholder="Innovation Thinking"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Project Management
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Project Management"
                            value={userData.project_management}
                            onChange={(e) => setProjectManagement(e.target.value)}
                            placeholder="Project Management"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Technical Adaptability
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Technical Adaptability"
                            value={userData.technical_adaptability}
                            onChange={(e) =>  setTechnicalAdaptability(e.target.value)}
                            placeholder="Technical Adaptability"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Workplace Maturity
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Workplace Maturity"
                            value={userData.workplace_maturity}
                            onChange={(e) => setWorkplaceMaturity(e.target.value)}
                            placeholder="Workplace Maturity"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">
                            Conflict Resolution
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="Conflict Resolution"
                            value={userData.conflict_resolution}
                            onChange={(e) => setConflictResolution(e.target.value)}
                            placeholder="Conflict Resolution"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Goal Orientation</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Goal Orientation"
                            value={userData.goal_orientation}
                            onChange={(e) => setGoalOrientation(e.target.value)}
                            placeholder="Goal Orientation"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Research Skills</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Research Skills"
                            value={userData.research_skills}
                            onChange={(e) => setResearchSkills(e.target.value)}
                            placeholder="Research Skills"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Customer Focus</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Customer Focus"
                            value={userData.customer_focus}
                            onChange={(e) => setCustomerFocus(e.target.value)}
                            placeholder="Customer Focus"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Teamwork</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Teamwork"
                            value={userData.teamwork}
                            onChange={(e) => setTeamwork(e.target.value)}
                            placeholder="Teamwork"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Multitasking</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Multitasking"
                            value={userData.multitasking}
                            onChange={(e) => setMultitasking(e.target.value)}
                            placeholder="Multitasking"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Vision</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Vision"
                            value={userData.vision}
                            onChange={(e) => setVision(e.target.value)}
                            placeholder="Vision"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Persistence</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Persistence"
                            value={userData.persistence}
                            onChange={(e) => setPersistence(e.target.value)}
                            placeholder="Persistence"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Self Improvement</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Self Improvement"
                            value={userData.self_improvement}
                            onChange={(e) => setSelfImprovement(e.target.value)}
                            placeholder="Self Improvement"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Business Acumen</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Business Acumen"
                            value={userData.business_acumen}
                            onChange={(e) => setBusinessAcumen(e.target.value)}
                            placeholder="Business Acumen"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Attendance</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Attendance"
                            value={userData.attendance}
                            onChange={(e) => setAttendance(e.target.value)}
                            placeholder="Attendance"
                          />
                        </div>
                        <div className="mb-2 col-lg-4 px-1">
                          <label className="form-label">Resume Score</label>
                          <input
                            type="number"
                            className="form-control"
                            name="Resume Score"
                            value={userData.resume_score}
                            onChange={(e) => setResumeScore(e.target.value)}
                            placeholder="Resume Score"
                          />
                        </div>
                        <div className="mt-1 p-2 text-end border-bottom-0 border-start-0 border-end-0 border-dashed border">
                          <button
                            type="submit"
                            onClick={handleSubmit}
                            className="btn btn-soft-primary"
                          >
                            Send
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              {/*end row*/}
            </div>

            <div className="col-lg-12 p-3 border rounded">
              <div className="card">
                <div className="card-body">
                  <div>
                    <h5 className="card-title">Student Placement Details</h5>
                    <ul className="list-group">
                      <div className="row">
                        <div className="col-lg-4">
                          <li className="list-group-item">
                            <strong>Technical Proficiency: </strong>
                            {userData.technical_proficiency}
                          </li>
                          <li className="list-group-item">
                            <strong>AI Awareness: </strong>
                            {userData.ai_awareness}
                          </li>
                          <li className="list-group-item">
                            <strong>Problem Solving: </strong>
                            {userData.problem_solving}
                          </li>
                          <li className="list-group-item">
                            <strong>Soft Skills: </strong>
                            {userData.soft_skills}
                          </li>
                          <li className="list-group-item">
                            <strong>Adaptability: </strong>
                            {userData.adaptability}
                          </li>
                          <li className="list-group-item">
                            <strong>Continuous Learning: </strong>
                            {userData.continuous_learning}
                          </li>
                          <li className="list-group-item">
                            <strong>Innovation: </strong>
                            {userData.innovation}
                          </li>
                          <li className="list-group-item">
                            <strong>Data Literacy: </strong>
                            {userData.data_literacy}
                          </li>
                          <li className="list-group-item">
                            <strong>Networking: </strong>
                            {userData.networking}
                          </li>
                          <li className="list-group-item">
                            <strong>Personal Branding: </strong>
                            {userData.personal_branding}
                          </li>
                          <li className="list-group-item">
                            <strong>Cultural Awareness: </strong>
                            {userData.cultural_awareness}
                          </li>
                          <li className="list-group-item">
                            <strong>Role Specific Skills: </strong>
                            {userData.role_specific_skills}
                          </li>
                          <li className="list-group-item">
                            <strong>Resilience: </strong>
                            {userData.resilience}
                          </li>
                          <li className="list-group-item">
                            <strong>Communication: </strong>
                            {userData.communication}
                          </li>
                          <li className="list-group-item">
                            <strong>Collaboration: </strong>
                            {userData.collaboration}
                          </li>
                          <li className="list-group-item">
                            <strong>Creativity: </strong>
                            {userData.creativity}
                          </li>
                          <li className="list-group-item">
                            <strong>Work Ethic: </strong>
                            {userData.work_ethic}
                          </li>
                          <li className="list-group-item">
                            <strong>Leadership: </strong>
                            {userData.leadership}
                          </li>
                          <li className="list-group-item">
                            <strong>Entrepreneurship: </strong>
                            {userData.entrepreneurship}
                          </li>
                          <li className="list-group-item">
                            <strong>Agility: </strong>
                            {userData.agility}
                          </li>
                        </div>
                        <div className="col-lg-4">
                          <li className="list-group-item">
                            <strong>Global Awareness: </strong>
                            {userData.global_awareness}
                          </li>
                          <li className="list-group-item">
                            <strong>Ethics: </strong>
                            {userData.ethics}
                          </li>
                          <li className="list-group-item">
                            <strong>Time Management: </strong>
                            {userData.time_management}
                          </li>
                          <li className="list-group-item">
                            <strong>Critical Thinking: </strong>
                            {userData.critical_thinking}
                          </li>
                          <li className="list-group-item">
                            <strong>Productivity: </strong>
                            {userData.productivity}
                          </li>
                          <li className="list-group-item">
                            <strong>Mentorship: </strong>
                            {userData.mentorship}
                          </li>
                          <li className="list-group-item">
                            <strong>Decision Making: </strong>
                            {userData.decision_making}
                          </li>
                          <li className="list-group-item">
                            <strong>Attention to Detail: </strong>
                            {userData.attention_to_detail}
                          </li>
                          <li className="list-group-item">
                            <strong>Emotional Intelligence: </strong>
                            {userData.emotional_intelligence}
                          </li>
                          <li className="list-group-item">
                            <strong>Self Motivation: </strong>
                            {userData.self_motivation}
                          </li>
                          <li className="list-group-item">
                            <strong>Accountability: </strong>
                            {userData.accountability}
                          </li>
                          <li className="list-group-item">
                            <strong>Interpersonal Skills: </strong>
                            {userData.interpersonal_skills}
                          </li>
                          <li className="list-group-item">
                            <strong>Feedback Reception: </strong>
                            {userData.feedback_reception}
                          </li>
                          <li className="list-group-item">
                            <strong>Stress Management: </strong>
                            {userData.stress_management}
                          </li>
                          <li className="list-group-item">
                            <strong>Self Discipline: </strong>
                            {userData.self_discipline}
                          </li>
                          <li className="list-group-item">
                            <strong>Public Speaking: </strong>
                            {userData.public_speaking}
                          </li>
                          <li className="list-group-item">
                            <strong>Innovation Thinking: </strong>
                            {userData.innovation_thinking}
                          </li>
                          <li className="list-group-item">
                            <strong>Project Management: </strong>
                            {userData.project_management}
                          </li>
                          <li className="list-group-item">
                            <strong>Technical Adaptability: </strong>
                            {userData.technical_adaptability}
                          </li>
                          <li className="list-group-item">
                            <strong>Workplace Maturity: </strong>
                            {userData.workplace_maturity}
                          </li>
                        </div>
                        <div className="col-lg-4">
                          <li className="list-group-item">
                            <strong>Conflict Resolution: </strong>
                            {userData.conflict_resolution}
                          </li>
                          <li className="list-group-item">
                            <strong>Goal Orientation: </strong>
                            {userData.goal_orientation}
                          </li>
                          <li className="list-group-item">
                            <strong>Research Skills: </strong>
                            {userData.research_skills}
                          </li>
                          <li className="list-group-item">
                            <strong>Customer Focus: </strong>
                            {userData.customer_focus}
                          </li>
                          <li className="list-group-item">
                            <strong>Teamwork: </strong>
                            {userData.teamwork}
                          </li>
                          <li className="list-group-item">
                            <strong>Multitasking: </strong>
                            {userData.multitasking}
                          </li>
                          <li className="list-group-item">
                            <strong>Vision: </strong>
                            {userData.vision}
                          </li>
                          <li className="list-group-item">
                            <strong>Persistence: </strong>
                            {userData.persistence}
                          </li>
                          <li className="list-group-item">
                            <strong>Self Improvement: </strong>
                            {userData.self_improvement}
                          </li>
                          <li className="list-group-item">
                            <strong>Business Acumen: </strong>
                            {userData.business_acumen}
                          </li>
                          <li className="list-group-item">
                            <strong>Attendance: </strong>
                            {userData.attendance}
                          </li>
                          <li className="list-group-item">
                            <strong>Education: </strong>
                            {userData.user_education[0] &&
                            userData.user_education.length > 0
                              ? userData.user_education[0].field_of_study
                              : "null"}
                          </li>
                          <li className="list-group-item">
                            <strong>Experience: </strong>
                            {userData.user_experience &&
                            userData.user_experience.length > 0
                              ? userData.user_experience[0].field_of_study
                              : "null"}
                          </li>
                          <li className="list-group-item">
                            <strong>Certifications: </strong>
                            {userData.user_certifications &&
                            userData.user_certifications.length > 0
                              ? userData.user_certifications[0].field_of_study
                              : "null"}
                          </li>
                          <li className="list-group-item">
                            <strong>Honours: </strong>
                            {userData.user_honours &&
                            userData.user_honours.length > 0
                              ? userData.user_honours[0].field_of_study
                              : "null"}
                          </li>
                          <li className="list-group-item">
                            <strong>Technical skills: </strong>
                            {userData.user_technical_skills[0] &&
                            userData.user_technical_skills.length > 0
                              ? userData.user_technical_skills[0].title
                              : "null"}
                          </li>
                          <li className="list-group-item">
                            <strong>Interpersonal skills: </strong>
                            {userData.user_interpersonal_skills &&
                            userData.user_interpersonal_skills.length > 0
                              ? userData.user_interpersonal_skills[0]
                                  .field_of_study
                              : "null"}
                          </li>
                          <li className="list-group-item">
                            <strong>Hobbies: </strong>
                            {userData.user_hobbies &&
                            userData.user_hobbies.length > 0
                              ? userData.user_hobbies[0].title
                              : "null"}
                          </li>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

export default PlacementItem;
